/**
 * avatars/items/mask.js
 * Xây dựng hình học 3D cho createMask
 */

import * as THREE from 'three';

export function createMask(lib, type, headSize) {
  const maskGroup = new THREE.Group();
  maskGroup.name = `Mask_${type}`;

  const maskColor = type === 'khau_trang_den' ? '#18181b' : '#f8fafc';
  // Quai đeo đồng bộ màu: khẩu trang đen dùng quai đen, khẩu trang trắng dùng quai trắng
  const strapColor = type === 'khau_trang_den' ? '#27272a' : '#e2e8f0';

  const maskMat = new THREE.MeshStandardMaterial({ color: maskColor, roughness: 0.8 });
  const strapMat = new THREE.MeshStandardMaterial({ color: strapColor, roughness: 0.8 });
  lib.disposables.push(maskMat, strapMat);

  const half = headSize / 2;
  const maskTop = headSize * 0.42;
  const maskBottom = headSize * 0.06;
  const maskH = maskTop - maskBottom;
  const maskY = (maskTop + maskBottom) / 2;

  // Mặt trước khẩu trang phủ trọn bề ngang mặt, từ sống mũi xuống cằm
  const maskGeo = new THREE.BoxGeometry(headSize + 0.02, maskH, 0.02);
  const maskMesh = new THREE.Mesh(maskGeo, maskMat);
  maskMesh.position.set(0, maskY, half + 0.01);
  maskGroup.add(maskMesh);

  // Nếp gấp ngang vải khẩu trang
  const pleatMat = new THREE.MeshStandardMaterial({
    color: new THREE.Color(maskColor).multiplyScalar(0.8),
    roughness: 0.85
  });
  lib.disposables.push(pleatMat);
  const pleatGeo = new THREE.BoxGeometry(headSize * 0.9, 0.008, 0.006);
  [0.35, 0.65].forEach((t) => {
    const pleat = new THREE.Mesh(pleatGeo, pleatMat);
    pleat.position.set(0, maskBottom + maskH * t, half + 0.022);
    maskGroup.add(pleat);
  });

  // 2 vạt ôm sang má (khẩu trang thật bọc cả gò má)
  const cheekDepth = headSize * 0.22;
  const cheekGeo = new THREE.BoxGeometry(0.02, maskH * 0.86, cheekDepth);
  [-1, 1].forEach((side) => {
    const cheek = new THREE.Mesh(cheekGeo, maskMat);
    cheek.position.set(side * (half + 0.01), maskY, half - cheekDepth / 2 + 0.01);
    maskGroup.add(cheek);
  });

  // Dây thun: 2 sợi (mép trên & mép dưới vạt má) chạy dọc hông đầu, chụm lại vòng qua tai
  const earPoint = new THREE.Vector3(0, headSize * 0.5, -headSize * 0.04);
  const strapStarts = [
    new THREE.Vector3(0, maskTop - 0.02, half - cheekDepth + 0.01),
    new THREE.Vector3(0, maskBottom + 0.03, half - cheekDepth + 0.01)
  ];
  [-1, 1].forEach((side) => {
    const x = side * (half + 0.012);
    strapStarts.forEach((start) => {
      const dy = earPoint.y - start.y;
      const dz = earPoint.z - start.z;
      const len = Math.hypot(dy, dz);
      const strapGeo = new THREE.BoxGeometry(0.012, 0.014, len);
      const strap = new THREE.Mesh(strapGeo, strapMat);
      strap.position.set(x, (earPoint.y + start.y) / 2, (earPoint.z + start.z) / 2);
      strap.rotation.x = Math.atan2(dy, -dz);
      maskGroup.add(strap);
      lib.disposables.push(strapGeo);
    });
    // Vòng thun vắt sau vành tai
    const loopGeo = new THREE.BoxGeometry(0.012, 0.06, 0.03);
    const loop = new THREE.Mesh(loopGeo, strapMat);
    loop.position.set(x, earPoint.y, earPoint.z - 0.012);
    maskGroup.add(loop);
    lib.disposables.push(loopGeo);
  });

  lib.disposables.push(maskGeo, pleatGeo, cheekGeo);
  return maskGroup;
}
